import { contracts } from '../../data/contracts'

export default {
	name: 'BUST',
	shortName: 'BST',
	contractAddress: contracts[process.env.REACT_APP_NETWORK].stableUSDT,
	url: 'http://lorem.com',
	logo: 'tokens/OFood.png'
}
